import { Grid2 as Grid, Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    platformStats,
    platformEvolution,
    clinicsStats,
    clinicAnalyticsById
} from './mock/managementDashboard.mock';
import PlatformSummaryCard from './componets/PlatformSummaryCard';
import PlatformEvolutionCard from './componets/PlatformEvolutionCard';
import ClinicsListCard from './componets/ClinicsListCard';
import ClinicDetailsCard from './componets/ClinicDetailsCard';

const ManagementDashboard = () => {
    const { t } = useTranslation();
    const [selectedClinicId, setSelectedClinicId] = useState(clinicsStats[0].uuid);
    const selectedClinicAnalytics = clinicAnalyticsById[selectedClinicId];

    return (
        <Box p={2} sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <Grid container spacing={1}>
                {/* Top Left */}
                <Grid size={{ xs: 12, md: 4 }}>
                    <PlatformSummaryCard stats={platformStats} />
                </Grid>

                {/* Top Right */}
                <Grid size={{ xs: 12, md: 8 }}>
                    <PlatformEvolutionCard data={platformEvolution} />
                </Grid>

                {/* Bottom Left */}
                <Grid size={{ xs: 12, md: 4 }}>
                    <ClinicsListCard
                        clinics={clinicsStats}
                        selectedClinicId={selectedClinicId}
                        onSelect={(clinic) => setSelectedClinicId(clinic.uuid)}
                    />
                </Grid>

                {/* Bottom Right */}
                <Grid size={{ xs: 12, md: 8 }}>
                    <ClinicDetailsCard clinic={selectedClinicAnalytics} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default ManagementDashboard;
